import { Component, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '@core/services/loading.service';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (loadingService.isLoading()) {
      <div class="global-loader">
        <div class="loader-bar">
          <div 
            class="loader-progress" 
            [style.width.%]="progress">
          </div>
        </div>
      </div>
    }
  `,
  styles: [`
    .global-loader {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 9999;
      height: 6px;
      background: rgba(165, 120, 255, 0.1);
      overflow: hidden;
    }

    .loader-bar {
      position: relative;
      width: 100%;
      height: 100%;
      background: transparent;
      overflow: hidden;
    }

    .loader-progress {
      height: 100%;
      background: #A578FF;
      transition: width 0.3s ease;
      border-radius: 0 3px 3px 0;
      box-shadow: 0 0 8px rgba(165, 120, 255, 0.4);
    }

    /* Smooth fade in/out */
    .global-loader {
      animation: fadeIn 0.3s ease-in-out;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  `]
})
export class GlobalLoaderComponent implements OnDestroy {
  loadingService = inject(LoadingService);
  progress = 0;
  
  private progressInterval?: any;
  private isCurrentlyLoading = false;

  constructor() {
    // Subscribe to loading service changes manually
    setInterval(() => {
      const isLoading = this.loadingService.isLoading();
      if (isLoading !== this.isCurrentlyLoading) {
        this.isCurrentlyLoading = isLoading;
        
        if (isLoading) {
          this.startProgress();
        } else {
          this.completeProgress();
        }
      }
    }, 100);
  }

  ngOnDestroy() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  }

  private startProgress() {
    this.progress = 0; // Start from 0
    
    // Clear any existing interval
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
    
    // Start smooth progress animation
    this.progressInterval = setInterval(() => {
      if (this.progress < 90) {
        // Smooth increment - starts faster, slows down as it approaches 90%
        const remaining = 90 - this.progress;
        const increment = Math.max(0.3, remaining * 0.02);
        this.progress = Math.min(90, this.progress + increment);
      }
    }, 50); // Update every 50ms for smoothness
  }

  private completeProgress() {
    // Complete the progress bar
    this.progress = 100;
    
    // Clear interval
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = undefined;
    }
    
    // Hide after a short delay
    window.setTimeout(() => {
      this.progress = 0;
    }, 300);
  }
}